import React, { useState, useContext, useEffect } from 'react'
import readXlsxFile from 'read-excel-file'
import xlsx from 'xlsx'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import {
   Box,
   Button,
   Card,
   CardContent,
   Typography,
   Menu,
   MenuItem,
   Dialog
} from '@material-ui/core'
import { toast } from 'react-toastify'
import { Share } from 'react-feather'
import ViewListIcon from '@material-ui/icons/ViewList'
import ViewListOutlineIcon from '@material-ui/icons/ViewListOutlined'
import ViewModuleIcon from '@material-ui/icons/ViewModule'
import ViewModuleOutlineIcon from '@material-ui/icons/ViewModuleOutlined'
import CloseIcon from '@material-ui/icons/Close'

// barcode scanner
import BarCodeScanner from '../barcode-scanner'
import Barcode from 'react-barcode'

// API
import { postPublicAPI, putPublicAPI, getPublicAPI } from '../../api'

// contexts
import { ToastContext } from '../../contexts/Toast'

const FittingListToolbar = props => {
   const { uploadedNewFits, setViewC, viewC, selectedFittingsC } = props.prop
   const { innerWidth: windowWidth } = window
   const { setToasts } = useContext(ToastContext)

   const [open, setOpen] = useState(false)
   const [fileUploaded, setFileUploaded] = useState(false)
   const [flag, setFlag] = useState(false)
   const [showBarcodes, setShowBarcodes] = useState(false)
   const [showFittings, setShowFittings] = useState(false)
   const [needsImages, setNeedsImages] = useState(false)
   const [needsProds, setNeedsProds] = useState([])

   const [fittingsUploaded, setFittingsUploaded] = useState([])

   const [anchorQuickDisconnects, setAnchorQuickDisconnects] = useState(null)
   const [openQuickDisconnects, setOpenQuickDisconnects] = useState(false)

   const handleQuickDisconnects = event => {
      setOpenQuickDisconnects(true)
      setAnchorQuickDisconnects(event.currentTarget)
   }

   const handleQuickDisconnectsClose = () => setOpenQuickDisconnects(false)

   const onFileChange = async event => await onFileUpload(event.target.files[0])

   const downloadSample = async () => {
      let signedUrl = await getPublicAPI('/generate-signed-url', {
         url: `samples/fittings-sample.xlsx`
      })

      if (signedUrl?.success) {
         let downloadLink = document.createElement('a')
         downloadLink.href = signedUrl.url
         downloadLink.download = 'fittings-sample.xlsx'
         downloadLink.click()
      }
   }

   const onImport = () => setOpen(true)

   const ImportFile = () => (
      <Box sx={{ p: 4 }}>
         <CloseIcon sx={{ float: 'right', color: 'black' }} onClick={handleClose} />
         <Typography variant='h3' sx={{ color: '#d22f25', fontWeight: 500, mb: 2 }}>
            Steps of the process:
         </Typography>
         <Typography variant='body1' sx={{ color: 'black' }}>
            1. Download the sample to view the required format of the file (recommended)
         </Typography>
         <Button
            sx={{ mb: 1, backgroundColor: '#3f51b5' }}
            onClick={downloadSample}
            variant='contained'
         >
            Download sample
         </Button>
         <Typography variant='body1' sx={{ color: 'black' }}>
            2. Import the .xlsx file of the fittings' information
         </Typography>
         <Button sx={{ mb: 1, p: 0 }}>
            <label
               className={`file-upload ${fileUploaded || flag ? `disabled` : ``}`}
               htmlFor={fileUploaded || flag ? '' : 'file-upload'}
            >
               <input
                  type='file'
                  style={{ display: 'none' }}
                  id='file-upload'
                  onChange={fileUploaded ? null : onFileChange}
                  label='import'
               />
               Import file
            </label>
         </Button>
         {/* <Typography variant='body1' sx={{ color: 'red', mb: 1 }}>
            NOTE: Do not refresh the page at any point during the process
         </Typography> */}
         <Typography variant='body1' sx={{ color: 'black' }}>
            3. Select all the images of the fittings (at once)
         </Typography>
         <Button sx={{ p: 0, mb: 1 }}>
            <label
               className={`file-upload ${!fileUploaded && !flag ? `disabled` : ``}`}
               htmlFor={!fileUploaded && !flag ? '' : 'files-upload'}
            >
               <input
                  type='file'
                  multiple={true}
                  style={{ display: 'none' }}
                  id='files-upload'
                  onChange={!fileUploaded && !flag ? null : onFilesChange}
                  label='import'
               />
               Import Images
            </label>
         </Button>
         {/* <Typography variant='body1' sx={{ color: 'black' }}>
            Refer to report for the details
         </Typography> */}
         <Typography variant='body1' sx={{ color: 'red', mb: 1 }}>
            Refer to report for the details
         </Typography>
         <Button variant='contained' onClick={handleClose} sx={{ mb: 1, float: 'right' }}>
            Done
         </Button>
      </Box>
   )

   const onFilesChange = async event => await onFilesUpload(event.target.files)

   const toBase64 = file =>
      new Promise((resolve, reject) => {
         const reader = new FileReader()
         reader.readAsDataURL(file)
         reader.onload = () => resolve(reader.result)
         reader.onerror = error => reject(error)
      })

   const onFilesUpload = async selectedFiles => {
      if (selectedFiles) {
         let filesData = []

         for await (let file of selectedFiles) {
            filesData.push({
               name: file.name.trim(),
               data: await toBase64(file)
            })
         }

         try {
            let fittingsUpdated = []

            await Promise.all(
               filesData.map(async fileData => {
                  let uploadedPic = await putPublicAPI('/upload-pictures', {
                     fileData
                  })

                  if (
                     uploadedPic?.success &&
                     uploadedPic?.report &&
                     !fittingsUpdated.includes(uploadedPic?.report) &&
                     !fittingsUploaded.includes(uploadedPic?.report)
                  )
                     fittingsUpdated.push(uploadedPic?.report)
               })
            )

            setToasts({
               type: 'success',
               messages: [{ msg: 'Pictures uploaded' }]
            })

            setFileUploaded(false)
            setFlag(false)
            setOpen(false)
            setNeedsImages(false)
            setNeedsProds([])

            localStorage.setItem('uploaded', 'Fits')
            // localStorage.setItem('fittings_updated', fittingsUpdated.length)

            setTimeout(() => {
               window.location.reload()
            }, 1000)
         } catch (err) {
            console.log(err)
            setToasts({
               type: 'error',
               messages: [{ msg: 'Some error occurred' }]
            })
         }
      }
   }

   const onFileUpload = async selectedFile => {
      if (selectedFile) {
         let fileData = []
         let rows = await readXlsxFile(selectedFile)

         await Promise.all(
            rows.slice(1, rows.length).map(async row => {
               let picsData = row[6]?.trim().split(',')
               let picsD = []
               await Promise.all(picsData.map(pic => pic.length > 0 && picsD.push(pic.trim())))

               if (row[7] === 'Add') {
                  setNeedsImages(true)
                  setNeedsProds(needsProds => [...needsProds, row[0]])

                  if (localStorage.fittings_added > 0)
                     localStorage.setItem(
                        'fittings_added',
                        parseInt(localStorage.fittings_added) + 1
                     )
                  else localStorage.setItem('fittings_added', 1)
               }

               if (row[7] === 'Update') {
                  if (localStorage.fittings_updated > 0)
                     localStorage.setItem(
                        'fittings_updated',
                        parseInt(localStorage.fittings_updated) + 1
                     )
                  else localStorage.setItem('fittings_updated', 1)
               }

               if (row[7] === 'Delete') {
                  if (localStorage.fittings_deleted > 0)
                     localStorage.setItem(
                        'fittings_deleted',
                        parseInt(localStorage.fittings_deleted) + 1
                     )
                  else localStorage.setItem('fittings_deleted', 1)
               }

               if (row[7] === 'Disable') {
                  if (localStorage.fittings_disabled > 0)
                     localStorage.setItem(
                        'fittings_disabled',
                        parseInt(localStorage.fittings_disabled) + 1
                     )
                  else localStorage.setItem('fittings_disabled', 1)
               }

               if (row[7] === 'Enable') {
                  if (localStorage.fittings_enabled > 0)
                     localStorage.setItem(
                        'fittings_enabled',
                        parseInt(localStorage.fittings_enabled) + 1
                     )
                  else localStorage.setItem('fittings_enabled', 1)
               }

               if (localStorage.fittings_total > 0)
                  localStorage.setItem('fittings_total', parseInt(localStorage.fittings_total) + 1)
               else localStorage.setItem('fittings_total', 1)

               let rowData = {
                  rhpn: row[0],
                  desc: row[1],
                  hSize: '0' + row[2],
                  dSize: '0' + row[3],
                  bQty: row[4],
                  lPrice: row[5],
                  operation: row[7],
                  pics: picsD,
                  pictures: []
               }

               fileData.push(rowData)
            })
         )

         let uploadFittings = await postPublicAPI('/upload-products', {
            fileData,
            updatedAt: new Date()
         })

         if (uploadFittings?.success) {
            setToasts({
               type: 'success',
               messages: uploadFittings.data
            })

            setFileUploaded(true)
            setFlag(true)
            setFittingsUploaded(uploadFittings?.report || [])

            localStorage.setItem('fitting_error', uploadFittings?.error)
            // localStorage.setItem('fittings_uploaded', uploadFittings?.report?.length)
         } else console.log(uploadFittings?.errors)
      }
   }

   const setIt = value => {
      setViewC(value)
      localStorage.setItem('view_c', value ? 1 : 0)
   }

   useEffect(() => {
      if (uploadedNewFits) uploadReport()
   }, [uploadedNewFits])

   const Msg = ({ closeToast }) => {
      let fittings_added = localStorage.fittings_added
      let fittings_updated = localStorage.fittings_updated
      let fittings_deleted = localStorage.fittings_deleted
      let fittings_disabled = localStorage.fittings_disabled
      let fittings_enabled = localStorage.fittings_enabled
      let fittings_total = localStorage.fittings_total
      let fitting_error = localStorage.fitting_error

      localStorage.removeItem('fittings_added')
      localStorage.removeItem('fittings_updated')
      localStorage.removeItem('fittings_deleted')
      localStorage.removeItem('fittings_disabled')
      localStorage.removeItem('fittings_enabled')
      localStorage.removeItem('fittings_total')
      localStorage.removeItem('fitting_error')

      return (
         <Box sx={{ justifyContent: 'flex-start', alignItems: 'flex' }}>
            <Typography sx={{ pb: 1 }} variant='h5' color='#d22f25'>
               Upload Summary:
            </Typography>
            <Typography
               sx={{ pb: 1 }}
               variant='body1'
               color='textPrimary'
            >{`No. of new records added: ${fittings_added || 0}`}</Typography>
            <Typography
               sx={{ pb: 1 }}
               variant='body1'
               color='textPrimary'
            >{`No. of records updated: ${fittings_updated || 0}`}</Typography>
            <Typography
               sx={{ pb: 1 }}
               variant='body1'
               color='textPrimary'
            >{`No. of records deleted: ${fittings_deleted || 0}`}</Typography>
            <Typography
               sx={{ pb: 1 }}
               variant='body1'
               color='textPrimary'
            >{`No. of records disabled: ${fittings_disabled || 0}`}</Typography>
            <Typography
               sx={{ pb: 1 }}
               variant='body1'
               color='textPrimary'
            >{`No. of records enabled: ${fittings_enabled || 0}`}</Typography>
            <Typography
               sx={{ pb: 1 }}
               variant='body1'
               color='textPrimary'
            >{`No. of records affected: ${fittings_total || 0}`}</Typography>
            {fitting_error && (
               <Box>
                  <Typography sx={{ pb: 1 }} variant='h6' color='#d22f25'>
                     Issues:
                  </Typography>
                  <Typography variant='body1' color='#d22f25'>
                     {fitting_error}
                  </Typography>
               </Box>
            )}
            <Button sx={{ float: 'right', pt: 1 }} variant='contained' onClick={closeToast}>
               Okay
            </Button>
         </Box>
      )
   }

   const uploadReport = () => {
      let position = toast.POSITION.TOP_CENTER
      let autoClose = false

      toast(<Msg />, { position, autoClose })
   }

   const getBase64FromUrl = async url => {
      try {
         const data = await fetch(url)
         const blob = await data.blob()
         return new Promise(resolve => {
            const reader = new FileReader()
            reader.readAsDataURL(blob)
            reader.onloadend = () => {
               const base64data = reader.result
               resolve(base64data)
            }
         })
      } catch {
         return
      }
   }

   const exportExcel = async data => {
      const newData = await Promise.all(
         data.map(async record => {
            let pictureString = ''

            if (record.pics?.length > 0) {
               await Promise.all(
                  record.pics.map((pic, index) =>
                     index === record.pics.length - 1
                        ? (pictureString += pic)
                        : (pictureString += pic + ', ')
                  )
               )
            }

            let newRecord = {
               'Part Number': record.rhpn,
               Description: record.desc,
               'hose size': record.hSize,
               'dash size': record.dSize,
               'Box Qty.': record.bQty,
               'List Price': record.lPrice,
               Picture: pictureString
            }

            return newRecord
         })
      )

      const newWorkBook = xlsx.utils.book_new()
      const newWorkSheet = xlsx.utils.json_to_sheet(newData)
      xlsx.utils.book_append_sheet(newWorkBook, newWorkSheet, 'Fittings')

      await xlsx.writeFile(newWorkBook, `fittings.xlsx`)
   }

   useEffect(() => {
      if (showBarcodes) {
         const prepareBarcodes = async () => {
            if (selectedFittingsC) {
               let zip = new JSZip()
               let barcode = zip.folder('barcodes')

               await Promise.all(
                  selectedFittingsC.map(async fitting => {
                     let base64Barcode = document.getElementById(fitting.rhpn).childNodes
                     let barcodeData = base64Barcode[0].currentSrc.replace(
                        /^data:image\/(png|gif|jpeg);base64,/,
                        ''
                     )

                     barcode.file(fitting.rhpn + '.jpg', barcodeData, { base64: true })

                     if (showFittings) {
                        let image = zip.folder('images')

                        if (fitting.pictures?.length > 0) {
                           await Promise.all(
                              fitting.pictures.map(async (pic, index) => {
                                 try {
                                    let base64Image = await getBase64FromUrl(pic)
                                    let imageData = base64Image.replace(
                                       /^data:image\/(png|gif|jpeg);base64,/,
                                       ''
                                    )

                                    image.file(fitting.pics[index], imageData, { base64: true })
                                 } catch {
                                    return
                                 }
                              })
                           )
                        }
                     }
                  })
               )

               if (showFittings) await exportExcel(selectedFittingsC)

               zip.generateAsync({ type: 'blob' }).then(function (content) {
                  saveAs(content, showFittings ? 'fittings.zip' : 'fittings-barcodes.zip')
               })

               setShowBarcodes(false)
               setShowFittings(false)
            }
         }

         prepareBarcodes()
      }
   }, [showBarcodes, showFittings, selectedFittingsC])

   const handleClose = () => {
      if (!(!fileUploaded && !flag) && needsImages) {
         const Info = ({ closeToast }) => {
            const closeInfoToast = () => {
               setNeedsImages(false)
               closeToast()
            }

            return (
               <Box sx={{ justifyContent: 'flex-start', alignItems: 'flex' }}>
                  <Typography sx={{ pb: 1 }} variant='h4' color='#d22f25'>
                     Important:
                  </Typography>
                  <Typography sx={{ pb: 1 }} variant='h6' color='#fff'>
                     Some fittings that you uploaded do not have images.
                  </Typography>
                  <Typography sx={{ pb: 1 }} variant='body1' color='#fff'>
                     Please upload images of the following fittings if you do not want a default
                     image.
                  </Typography>
                  <Box sx={{ maxHeight: '150px', overflow: 'scroll' }}>
                     {needsProds.map((prod, index) => (
                        <Typography sx={{ pb: 1 }} variant='body1' color='#fff'>
                           {index + 1 + '. ' + prod}
                        </Typography>
                     ))}
                  </Box>
                  <Button
                     sx={{ float: 'right', pt: 1 }}
                     variant='contained'
                     onClick={closeInfoToast}
                  >
                     Okay
                  </Button>
               </Box>
            )
         }

         let position = toast.POSITION.TOP_CENTER
         let autoClose = false

         toast(<Info />, { position, autoClose, style: { background: '#c0c0c0' } })
      } else {
         if (fileUploaded) uploadReport()

         setOpen(false)
         setFileUploaded(false)
         setFlag(false)
      }
   }

   const setFittings = () => {
      setShowBarcodes(true)
      setShowFittings(true)
   }

   const isAdmin = localStorage.user_type !== 'customer' ? true : false
   return (
      <Box {...props}>
         {isAdmin ? (
            <>
               {windowWidth > 425 && (
                  <Card className='header-card'>
                     <CardContent sx={{ justifyContent: 'center' }}>
                        <Box sx={{ float: 'left', mr: 2 }}>
                           <BarCodeScanner />
                        </Box>

                        <Button onClick={onImport}>Import</Button>
                        <Dialog
                           open={open}
                           onClose={handleClose}
                           // aria-labelledby='alert-dialog-title'
                           // aria-describedby='alert-dialog-description'
                        >
                           <ImportFile />
                           {/* <DialogTitle id='alert-dialog-title'>
                        {"Use Google's location service?"}
                     </DialogTitle>
                     <DialogContent>
                        <DialogContentText id='alert-dialog-description'>
                           Let Google help apps determine location. This means sending anonymous
                           location data to Google, even when no apps are running.
                        </DialogContentText>
                     </DialogContent>
                     <DialogActions>
                        <Button onClick={handleClose} color='primary'>
                           Disagree
                        </Button>
                        <Button onClick={handleClose} color='primary' autoFocus>
                           Agree
                        </Button>
                     </DialogActions> */}
                        </Dialog>
                        <Button
                           sx={{ mr: 2 }}
                           aria-owns={openQuickDisconnects ? 'quick-disconnects' : null}
                           aria-haspopup='true'
                           onClick={handleQuickDisconnects}
                        >
                           Export
                        </Button>
                        {showBarcodes &&
                           selectedFittingsC.map(fitting => (
                              <Box key={fitting.rhpn} sx={{ display: 'none' }} id={fitting.rhpn}>
                                 <Barcode
                                    format='CODE128'
                                    width={2}
                                    height={100}
                                    renderer={'img'}
                                    value={fitting.rhpn}
                                 />
                              </Box>
                           ))}
                        {/* {showFittings &&
                     selectedFittingsC.map(fitting => (
                        <Box key={fitting.rhpn}>
                           <Box sx={{ display: 'none' }} id={fitting.rhpn}>
                              <Barcode
                                 format='CODE128'
                                 width={2}
                                 height={100}
                                 renderer={'img'}
                                 value={fitting.rhpn}
                              />
                           </Box>
                           <Box sx={{ display: 'none' }}>
                              {fitting.pictures?.length > 0 && (
                                 <>
                                    {fitting.pictures.map((image, index) => (
                                       <Box key={index} id={fitting.pics[index]}>
                                          <img
                                             className='fitting-images'
                                             alt={fitting + index}
                                             src={image}
                                          />
                                       </Box>
                                    ))}
                                 </>
                              )}
                           </Box>
                        </Box>
                     ))} */}
                        <Menu
                           id='quick-disconnects'
                           className='nav-menu'
                           anchorEl={anchorQuickDisconnects}
                           open={openQuickDisconnects}
                           onClose={handleQuickDisconnectsClose}
                           PaperProps={{
                              style: {
                                 width: 200
                              }
                           }}
                        >
                           <MenuItem
                              onClick={() =>
                                 selectedFittingsC?.length > 0 ? setShowBarcodes(true) : null
                              }
                           >
                              <Share className='nav-dropdown' />
                              Barcodes
                           </MenuItem>
                           <MenuItem
                              onClick={() => (selectedFittingsC?.length > 0 ? setFittings() : null)}
                           >
                              <Share className='nav-dropdown' />
                              All Data
                           </MenuItem>
                        </Menu>
                        {/* <Button color='primary' variant='contained'>
                     Add fitting
                  </Button> */}
                        {windowWidth > 425 && (
                           <Box sx={{ float: 'right' }}>
                              <Button onClick={() => setIt(true)}>
                                 {viewC ? (
                                    <ViewModuleIcon fontSize='large' />
                                 ) : (
                                    <ViewModuleOutlineIcon color='disabled' fontSize='large' />
                                 )}
                              </Button>
                              <Button onClick={() => setIt(false)}>
                                 {viewC ? (
                                    <ViewListOutlineIcon color='disabled' fontSize='large' />
                                 ) : (
                                    <ViewListIcon fontSize='large' />
                                 )}
                              </Button>
                           </Box>
                        )}
                     </CardContent>
                  </Card>
               )}

               {windowWidth <= 425 && (
                  <Box className={'admin-header'}>
                     <Box className='admin-action-container'>
                        <Box>
                           <BarCodeScanner />
                        </Box>

                        <Button onClick={onImport}>Import</Button>
                        <Dialog
                           open={open}
                           onClose={handleClose}
                           // aria-labelledby='alert-dialog-title'
                           // aria-describedby='alert-dialog-description'
                        >
                           <ImportFile />
                           {/* <DialogTitle id='alert-dialog-title'>
                        {"Use Google's location service?"}
                     </DialogTitle>
                     <DialogContent>
                        <DialogContentText id='alert-dialog-description'>
                           Let Google help apps determine location. This means sending anonymous
                           location data to Google, even when no apps are running.
                        </DialogContentText>
                     </DialogContent>
                     <DialogActions>
                        <Button onClick={handleClose} color='primary'>
                           Disagree
                        </Button>
                        <Button onClick={handleClose} color='primary' autoFocus>
                           Agree
                        </Button>
                     </DialogActions> */}
                        </Dialog>
                        <Button
                           sx={{ mr: 2 }}
                           aria-owns={openQuickDisconnects ? 'quick-disconnects' : null}
                           aria-haspopup='true'
                           onClick={handleQuickDisconnects}
                        >
                           Export
                        </Button>
                        {showBarcodes &&
                           selectedFittingsC.map(fitting => (
                              <Box key={fitting.rhpn} sx={{ display: 'none' }} id={fitting.rhpn}>
                                 <Barcode
                                    format='CODE128'
                                    width={2}
                                    height={100}
                                    renderer={'img'}
                                    value={fitting.rhpn}
                                 />
                              </Box>
                           ))}
                        {/* {showFittings &&
                     selectedFittingsC.map(fitting => (
                        <Box key={fitting.rhpn}>
                           <Box sx={{ display: 'none' }} id={fitting.rhpn}>
                              <Barcode
                                 format='CODE128'
                                 width={2}
                                 height={100}
                                 renderer={'img'}
                                 value={fitting.rhpn}
                              />
                           </Box>
                           <Box sx={{ display: 'none' }}>
                              {fitting.pictures?.length > 0 && (
                                 <>
                                    {fitting.pictures.map((image, index) => (
                                       <Box key={index} id={fitting.pics[index]}>
                                          <img
                                             className='fitting-images'
                                             alt={fitting + index}
                                             src={image}
                                          />
                                       </Box>
                                    ))}
                                 </>
                              )}
                           </Box>
                        </Box>
                     ))} */}
                        <Menu
                           id='quick-disconnects'
                           className='nav-menu'
                           anchorEl={anchorQuickDisconnects}
                           open={openQuickDisconnects}
                           onClose={handleQuickDisconnectsClose}
                           PaperProps={{
                              style: {
                                 width: 200
                              }
                           }}
                        >
                           <MenuItem
                              onClick={() =>
                                 selectedFittingsC?.length > 0 ? setShowBarcodes(true) : null
                              }
                           >
                              <Share className='nav-dropdown' />
                              Barcodes
                           </MenuItem>
                           <MenuItem
                              onClick={() => (selectedFittingsC?.length > 0 ? setFittings() : null)}
                           >
                              <Share className='nav-dropdown' />
                              All Data
                           </MenuItem>
                        </Menu>
                        {/* <Button color='primary' variant='contained'>
                     Add fitting
                  </Button> */}
                     </Box>
                  </Box>
               )}
            </>
         ) : (
            <>
               <Box sx={{ mb: 2 }}>
                  {windowWidth <= 425 && (
                     <Box sx={{ textAlign: 'center' }}>
                        <BarCodeScanner />
                     </Box>
                  )}
                  {windowWidth > 425 && (
                     <Card className='header-card'>
                        <CardContent sx={{ justifyContent: 'center' }}>
                           <Box sx={{ float: 'left' }}>
                              <BarCodeScanner />
                           </Box>

                           <Box sx={{ float: 'right' }}>
                              <Button onClick={() => setIt(true)}>
                                 {viewC ? (
                                    <ViewModuleIcon fontSize='large' />
                                 ) : (
                                    <ViewModuleOutlineIcon color='disabled' fontSize='large' />
                                 )}
                              </Button>
                              <Button onClick={() => setIt(false)}>
                                 {viewC ? (
                                    <ViewListOutlineIcon color='disabled' fontSize='large' />
                                 ) : (
                                    <ViewListIcon fontSize='large' />
                                 )}
                              </Button>
                           </Box>
                        </CardContent>
                     </Card>
                  )}
               </Box>
            </>
         )}
      </Box>
   )
}

export default FittingListToolbar
